import {MuiButtonBase, MuiButton, MuiIconButton, MuiListItemButton} from "./button"
import {MuiFormLabel} from "./formLabel"
import {MuiInputBase, MuiOutlinedInput} from "./input"
import {MuiTypography, MuiCssBaseline} from "./typography"
import {MuiList, MuiListItemText} from "./list"
import {MuiToolTip} from "./toolTip"

export const components = {
    MuiButtonBase,
    MuiButton,
    MuiFormLabel,
    MuiInputBase,
    MuiOutlinedInput,
    MuiIconButton,
    MuiListItemButton,
    MuiTypography,
    MuiCssBaseline,
    MuiList,
    MuiListItemText,
    MuiToolTip,
}
